import { createReporter } from './stackdriver-reporter';
import initData from 'init-data';

const reportToStackdriver = initData.stackdriverForJavaScriptEnabled
    ? createReporter({
          apiKey: initData.stackdriverForJavaScriptApiKey,
          projectId: initData.stackdriverForJavaScriptProjectId
      })
    : null;

const exceptionToString = sentryExceptionOrNull => {
    const exception = sentryExceptionOrNull || { values: [] };
    const lines = [];
    exception.values.forEach((exceptionValue, exceptionIndex) => {
        const stacktrace = exceptionValue.stacktrace || {
            type: '-',
            value: '-',
            frames: []
        };
        if (exceptionIndex > 0) {
            lines.push(`\n`);
        }
        lines.push(
            `Error: Type: ${exceptionValue.type} Value: ${
                exceptionValue.value
            }\n`
        );
        stacktrace.frames.forEach(frame => {
            const functionName = frame.function || '<anonymous>';
            lines.push(
                `    at ${functionName} (${frame.filename}:${frame.lineno}:${
                    frame.colno
                })\n`
            );
        });
    });
    return lines.join('');
};

export const customSentryBeforeSend = evt => {
    if (!reportToStackdriver) return evt;
    // Sentry uses console so do not log anything here.
    // If an error happens here Sentry will catch it to
    // avoid an infinite loop.
    const message = exceptionToString(evt.exception);
    reportToStackdriver(message);
    return evt;
};
